import React, { useEffect } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom-v5';
import { useDispatch } from 'react-redux';
import WorksheetExportable from 'spw-programming-projects/downloads/exportables/worksheet-exportable';
import ProgramSummaryCalculationsExportable from 'spw-programming-projects/downloads/exportables/program-summary-calculations-exportable';
import ProgramSummaryExportable from 'spw-programming-projects/reports/exportables/program-summary-exportable';
import SeatCountAnalysisExportable from 'spw-programming-projects/downloads/exportables/seat-count-analysis-exportable';
import NotesExportable from 'spw-programming-projects/downloads/exportables/notes-exportable';
import ESAProgramSummaryExportable from 'spw-esa-projects/reports/exportables/program-summary-exportable';
import OAndUCardsExportable from 'spw-esa-projects/reports/exportables/o-and-u-cards-exportable';
import { fetchUser } from 'spw-redux/modules/user/actions';
import BenchmarkReportExportable from '../../benchmark-reports/exportables/benchmark-report-exportable';

const ExportChooser: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchUser());
  }, [dispatch]);
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        exact
        path={[
          `${path}/projects/programming/:projectId/scenarios/:scenarioId/worksheet`,
          `${path}/projects/programming/:projectId/total-programs/:totalProgramId/worksheet`,
        ]}
        component={WorksheetExportable}
      />
      <Route
        exact
        path={[
          `${path}/projects/programming/:projectId/scenarios/:scenarioId/summaryCalculations`,
          `${path}/projects/programming/:projectId/total-programs/:totalProgramId/summaryCalculations`,
        ]}
        component={ProgramSummaryCalculationsExportable}
      />
      <Route
        exact
        path={[
          `${path}/projects/programming/:projectId/scenarios/:scenarioId/programSummary`,
          `${path}/projects/programming/:projectId/total-programs/:totalProgramId/programSummary`,
        ]}
        component={ProgramSummaryExportable}
      />
      <Route
        exact
        path={[
          `${path}/projects/programming/:projectId/scenarios/:scenarioId/seatCountAnalysis`,
          `${path}/projects/programming/:projectId/total-programs/:totalProgramId/seatCountAnalysis`,
        ]}
        component={SeatCountAnalysisExportable}
      />
      <Route
        exact
        path={[
          `${path}/projects/programming/:projectId/scenarios/:scenarioId/notes`,
          `${path}/projects/programming/:projectId/total-programs/:totalProgramId/notes`,
        ]}
        component={NotesExportable}
      />

      <Route
        exact
        path={[
          `${path}/projects/esa/:projectId/buildings/:buildingId/programSummary`,
          `${path}/projects/esa/:projectId/floors/:floorId/programSummary`,
        ]}
        component={ESAProgramSummaryExportable}
      />

      <Route
        exact
        path={[`${path}/projects/esa/:projectId/occupancyAndUtilization/cards`]}
        component={OAndUCardsExportable}
      />

      <Route
        exact
        path={[`${path}/benchmark-reports/:reportId/benchmarkReportSummary`]}
        component={BenchmarkReportExportable}
      />
    </Switch>
  );
};

export default ExportChooser;
